module.exports = __webpack_public_path__ + "img/1512582253.42820a0e.jpg";